module.exports = __webpack_public_path__ + "img/symbol_3.37f88743.png";